import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import LayoutHeader from "../../Common/Layout/Header";
import LayoutSidebar from "../../Common/Layout/Sidebar";
const initialFieldValues = {
  categoryId: "00000000-0000-0000-0000-000000000000",
  parentCategoryId: "00000000-0000-0000-0000-000000000000",
  categoryName: "",
};
export default function Category() {
  const [lists, setLists] = useState([]);
  const [values, setValues] = useState(initialFieldValues);
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [errors, setErrors] = useState({});
  const [btnSubmit, setBtnSubmit] = useState(true);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [categories, setCategories] = useState([]);
  const headerconfig = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("userToken"),
    },
  };
  useEffect(() => {
    if (recordForEdit !== null) {
      setValues(recordForEdit);
    }
  }, [recordForEdit]);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };
  const resetForm = () => {
    setValues(initialFieldValues);
    setErrors({});
  };
  const showEditDetails = (data) => {
    setRecordForEdit(data);
  };
  const GetPageData = (number) => {
    if (number >= 1 && number <= totalPages) {
      setPageNumber(number);
      GetData(number);
    }
  };
  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }
  const renderPageNumbers = pageNumbers.map((number) => {
    return (
      <li
        className="page-item"
        key={number}
        id={number}
        onClick={() => GetPageData(number)}
      >
        <Link className="page-link">{number}</Link>
      </li>
    );
  });

  const validate = () => {
    let temp = {};
    temp.categoryName = values.categoryName === "" ? false : true;
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      setBtnSubmit(false);
      const formData = new FormData();
      formData.append("categoryId", values.categoryId);
      formData.append("categoryName", values.categoryName);
      formData.append("parentCategoryId", values.parentCategoryId);
      addOrEdit(formData);
    }
  };
  const applicationAPI = () => {
    return {
      create: (newrecord) =>
        axios.post(config.APIACTIVATEURL + config.CREATECATEGORY, newrecord, {
          ...headerconfig,
        }),
      update: (updateRecord) =>
        axios.put(config.APIACTIVATEURL + config.UPDATECATEGORY, updateRecord, {
          ...headerconfig,
        }),
    };
  };
  const addOrEdit = (formData) => {
    if (formData.get("categoryId") === "00000000-0000-0000-0000-000000000000") {
      applicationAPI()
        .create(formData)
        .then((res) => {
          if (res.data.statusCode === 200) {
            handleSuccess(res.data.data);
            resetForm();
            GetData(pageNumber);
            setBtnSubmit(true);
            GetCategories();
          } else {
            handleError(res.data.data);
            setBtnSubmit(true);
          }
        })
        .catch(function (error) {
          handleError("Error in saving data");
          setBtnSubmit(true);
        });
    } else {
      applicationAPI()
        .update(formData)
        .then((res) => {
          if (res.data.statusCode === 200) {
            handleSuccess(res.data.data);
            resetForm();
            GetData(pageNumber);
            setBtnSubmit(true);
            GetCategories();
          } else {
            handleError(res.data.data);
            setBtnSubmit(true);
          }
        })
        .catch(function (error) {
          handleError("Error in updating data");
          setBtnSubmit(true);
        });
    }
  };
  const onDelete = (e, id) => {
    if (window.confirm("Are you sure to delete this record?")) {
      axios
        .delete(config.APIACTIVATEURL + config.DELETECATEGORY + "/" + id, {
          ...headerconfig,
        })
        .then((response) => {
          if (response.data.statusCode === 200) {
            handleSuccess(response.data.data);
            GetData(pageNumber);
            resetForm();
            GetCategories();
          } else {
            handleError(response.data.data);
            GetData(pageNumber);
            resetForm();
          }
        });
    }
  };
  const GetData = (number) => {
    axios
      .get(
        config.APIACTIVATEURL +
          config.GETCATEGORIES +
          "?pageNumber=" +
          number +
          "&pageSize=" +
          pageSize +
          "",
        { ...headerconfig }
      )
      .then((response) => {
        setLists(response.data.data.data);
        setPageNumber(response.data.data.pageNumber);
        setPageSize(response.data.data.pageSize);
        setTotalPages(response.data.data.totalPages);
        setData(response.data.data);
        setTotalRecords(response.data.data.totalRecords);
      });
  };
  const GetCategories = () => {
    axios
      .get(config.APIACTIVATEURL + config.GETALLCATEGORIES, {
        ...headerconfig,
      })
      .then((response) => {
        setCategories(response.data.data);
      });
  };
  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";
  useEffect(() => {
    GetData(pageNumber);
    GetCategories();
  }, []);
  return (
    <div id="layout-wrapper">
      <LayoutHeader></LayoutHeader>
      <LayoutSidebar></LayoutSidebar>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0">Category</h4>
                </div>
              </div>
            </div>
            <div className="alert alert-success">
              <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                <div className="row">
                  <div className="col-lg-3">
                    <div className="mb-3">
                      <label htmlFor="categoryName" className="form-label">
                        Category
                      </label>
                      <input
                        type="text"
                        name="categoryName"
                        value={values.categoryName}
                        onChange={handleInputChange}
                        className={
                          "form-control " + applyErrorClass("categoryName")
                        }
                        placeholder="Please Enter Category"
                      />
                      {errors.categoryName === false ? (
                        <div className="validationerror">
                          Please select categoryName{" "}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="mb-3">
                      <label htmlFor="parentCategoryId" className="form-label">
                        Parent Category
                      </label>
                      <select
                        name="parentCategoryId"
                        value={values.parentCategoryId}
                        onChange={handleInputChange}
                        className="form-select"
                      >
                        <option value="00000000-0000-0000-0000-000000000000">
                          All
                        </option>
                        {categories.map((c) => (
                          <option key={c.categoryId} value={c.categoryId}>
                            {c.categoryName}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                      {btnSubmit === true ? (
                        <button type="submit" className="btn btn-primary w-100">
                          {values.categoryId ===
                          "00000000-0000-0000-0000-000000000000"
                            ? "Submit"
                            : "Update"}
                        </button>
                      ) : (
                        <button
                          type="submit"
                          className="btn btn-primary w-100"
                          disabled
                        >
                          Please wait...
                        </button>
                      )}
                      <button
                        type="button"
                        className="btn btn-danger w-100"
                        onClick={resetForm}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div className="row">
              <div className="col-xl-12">
                <div className="card card-height-100">
                  <div className="card-body">
                    <div className="table-responsive table-card">
                      <table className="table align-middle" id="customerTable">
                        <thead className="table-light">
                          <tr>
                            <th>S.No</th>
                            <th>category</th>
                            <th>ParentCategory</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody className="list form-check-all">
                          {lists.length > 0 &&
                            lists.map((v, index) => (
                              <tr key={v.categoryId}>
                                <td>
                                  {(pageNumber - 1) * pageSize + (index + 1)}
                                </td>
                                <td>{v.categoryName}</td>
                                <td>{v.parentCategoryName}</td>

                                <td>
                                  <ul className="list-inline hstack gap-2 mb-0">
                                    <li
                                      className="list-inline-item"
                                      data-bs-toggle="tooltip"
                                      data-bs-trigger="hover"
                                      data-bs-placement="top"
                                      title="Edit"
                                    >
                                      <Link
                                        className="edit-item-btn"
                                        onClick={(e) => showEditDetails(v)}
                                      >
                                        <i className="ri-pencil-fill align-bottom text-muted" />
                                      </Link>
                                    </li>
                                    <li
                                      className="list-inline-item"
                                      data-bs-toggle="tooltip"
                                      data-bs-trigger="hover"
                                      data-bs-placement="top"
                                      title="Delete"
                                    >
                                      <Link
                                        className="remove-item-btn"
                                        onClick={(e) =>
                                          onDelete(e, v.categoryId)
                                        }
                                      >
                                        <i className="ri-delete-bin-fill align-bottom text-muted" />
                                      </Link>
                                    </li>
                                  </ul>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                      <div className="flex-shrink-0">
                        <div className="text-muted">
                          Showing{" "}
                          <span className="fw-semibold">{lists.length}</span> of{" "}
                          <span className="fw-semibold">{totalRecords}</span>{" "}
                          Results
                        </div>
                      </div>
                      <ul className="pagination pagination-separated pagination-sm mb-0">
                        <li
                          className={
                            "page-item " + (pageNumber === 1 ? "disabled" : "")
                          }
                          onClick={() => GetPageData(pageNumber - 1)}
                        >
                          <Link className="page-link">Previous</Link>
                        </li>
                        {renderPageNumbers}
                        <li
                          className={
                            "page-item " +
                            (pageNumber === totalPages ? "disabled" : "")
                          }
                          onClick={() => GetPageData(pageNumber + 1)}
                        >
                          <Link className="page-link">Next</Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
